module.exports = __webpack_public_path__ + "img/17851_L.517fee27.png";